"use strict";

define('model/group.member',['./base', './person'], function (BaseModel, PersonModel) {
  var GroupMember = BaseModel.extend({
    childModels: {
      person: PersonModel
    },
    virtual: {
      personDisplayName: BaseModel.createKeyPathVirtual('person.displayName')
    }
  });
  return GroupMember;
});

